import * as React from 'react';
import PropTypes from 'prop-types';
import { Table, TabbedCard, Tab } from 'tabler-react';
import dayjs from 'dayjs';

class AffiliateTable extends React.PureComponent {
  renderRecommendRow(bonus) {
    const statusMap = {
      CONFIRM: '已结算',
      UNCONFIRM: '待结算',
    };
    return (
      <Table.Row key={bonus._id}>
        <Table.Col> {statusMap[bonus.status]} </Table.Col>
        <Table.Col> {dayjs(bonus.paidAt).format('YYYY-MM-DD')} </Table.Col>
        <Table.Col>{bonus.userEmail}</Table.Col>
        <Table.Col>
          <strong> $ {bonus.affBonus} </strong>
        </Table.Col>
      </Table.Row>
    );
  }

  renderWithdrawRow(withdraw) {
    const map = {
      WITHDRAWED: '成功',
      FAILED: `失败 [${withdraw.failedMessage}]`,
      CREATED: '审核中',
    };

    const desc = map[withdraw.state] || '未知 请联系客服';
    return (
      <Table.Row key={withdraw._id}>
        <Table.Col>{dayjs(withdraw.createdAt).format('YYYY-MM-DD')}</Table.Col>
        <Table.Col>{withdraw.account}</Table.Col>
        <Table.Col>{withdraw.realAmount}</Table.Col>
        <Table.Col>{desc}</Table.Col>
      </Table.Row>
    );
  }

  renderHeader(titles) {
    return (
      <Table.Row>
        {titles.map(title => (
          <Table.Col>{title}</Table.Col>
        ))}
      </Table.Row>
    );
  }

  render() {
    const { bonuses, withdrawList, initialTab } = this.props;
    const titles = {
      recommend: ['返现状态', '购买时间', '购买用户', '返现金额'],
      withdraw: ['申请时间', '提现账号', '申请金额', '申请状态'],
    };
    const tabTitles = {
      bonus: `推荐记录`,
      withdrawList: `提现记录`,
    };
    return (
      <TabbedCard initialTab={initialTab}>
        <Tab title={tabTitles.bonus} className="test">
          <span className="aff-table-tag">总条数 {bonuses.length}</span>
          <Table className="card-table table-vcenter">
            <Table.Body>
              {this.renderHeader(titles.recommend)}
              {bonuses.map(bonus => this.renderRecommendRow(bonus))}
            </Table.Body>
          </Table>
        </Tab>
        <Tab title={tabTitles.withdrawList}>
          <Table className="card-table table-vcenter">
            <span className="aff-table-tag aff-tag-withdraw">
              总条数 {withdrawList.length}
            </span>
            <Table.Body>
              {this.renderHeader(titles.withdraw)}
              {withdrawList.map(withdraw => this.renderWithdrawRow(withdraw))}
            </Table.Body>
          </Table>
        </Tab>
      </TabbedCard>
    );
  }
}

AffiliateTable.propTypes = {
  bonuses: PropTypes.array,
  withdrawList: PropTypes.array,
  initialTab: PropTypes.string,
};

export default AffiliateTable;
